module.exports = __webpack_public_path__ + "img/banner2_9_en.e9193668.png";